import { render, staticRenderFns } from "./Programas.vue?vue&type=template&id=32912b7a&"
import script from "./Programas.vue?vue&type=script&lang=js&"
export * from "./Programas.vue?vue&type=script&lang=js&"
import style0 from "./Programas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports